export function enhancedFormData(formData: any, url: string): any {
    formData.originUrl = url;
    const today = new Date();
    formData.date = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;
    return formData;
}